import { render } from "./ProfileTrends.vue?vue&type=template&id=46917944"
import script from "./ProfileTrends.vue?vue&type=script&lang=js"
export * from "./ProfileTrends.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__